import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Button } from "@mui/material";
import { getEmailTemplateDesigns } from "./Helper";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

const EmailTemplateDesignList = () => {
  const context = useOutletContext();
  const navigate = useNavigate();
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    context(["Email Templates", "Template Design List"]);
    fetchDesigns();
  }, []);

  const fetchDesigns = () => {
    setLoading(true);
    getEmailTemplateDesigns()
      .then((res) => {
        console.log(res.data);
        const designsArray = res.data?.emailTemplateDesign || [];
        setDesigns(designsArray);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleCreate = () => {
    // Navigate to design page without creating first
    navigate("/EmailTemplates/Templates/Design", {
      state: { id: null, isNew: true },
    });
  };

  const handleEdit = (design) => {
    navigate("/EmailTemplates/Templates/Design", {
      state: { id: design.id, name: design.name },
    });
  };

  return (
    <div className="p-5 shadow-md bg-white">
      <div className="flex justify-between items-center mb-4">
        <h3
          className="text-lg uppercase tracking-wider font-bold"
          style={{ color: "#2EBAA3" }}
        >
          Template Design List
        </h3>
        <Button
          type="button"
          variant="contained"
          style={{ color: "white" }}
          onClick={handleCreate}
        >
          Create Template Design
        </Button>
      </div>
      <br />
      {loading ? (
        <div className="text-center py-10">Loading...</div>
      ) : designs.length === 0 ? (
        <div className="text-center py-10">
          <p className="text-gray-500 mb-4">No template designs found.</p>
        </div>
      ) : (
        <div class="overflow-x-auto relative">
          <table class="w-full text-sm text-left text-gray-500">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50">
              <tr>
                <th scope="col" class="py-3 px-6 uppercase">
                  Template Name
                </th>
                <th scope="col" class="py-3 px-6 uppercase text-center">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {designs?.map((design, index) => {
                return (
                  <tr class="bg-white border-b" key={design?.id || index}>
                    <td class="py-4 px-6 font-medium text-gray-900">
                      {design?.name || "Unnamed Template"}
                    </td>
                    <td class="py-4 px-6 text-center">
                      <IconButton
                        aria-label="edit"
                        onClick={() => handleEdit(design)}
                      >
                        <EditIcon />
                      </IconButton>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EmailTemplateDesignList;

